module.exports = __webpack_public_path__ + "static/media/sabotage4.0b6f7760.png";